import { AlertTriangle, CheckCircle2, Trash2 } from 'lucide-react-native';
import React, { memo } from 'react';
import { Text, View } from 'react-native';

import { Color } from '@/styles/GlobalStyles';

import { styles } from './styles';

type ICardRowProps = {
  id: number;
  form: string;
  startDate: string;
  duration: string;
  status: string;
};

function CardRowComponent({
  id,
  form,
  startDate,
  duration,
  status,
}: ICardRowProps) {
  const getIcon = (currentStatus: string) => {
    switch (currentStatus) {
      case 'Descartada':
        return <Trash2 style={styles.icon} stroke={Color.gray[300]} />;
      case 'Válida':
        return (
          <CheckCircle2 style={styles.icon} stroke={Color.secondary.green} />
        );
      case 'Não Considerada':
        return (
          <AlertTriangle style={styles.icon} stroke={Color.secondary.red} />
        );

      default:
        // Default fallback
        return <CheckCircle2 style={styles.icon} stroke={Color.gray[300]} />;
    }
  };

  return (
    <View style={styles.card}>
      <View style={styles.row}>
        <Text style={styles.label}>ID</Text>
        <Text style={styles.value}>{id}</Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.label}>Questionário</Text>
        <Text style={styles.value}>{form}</Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.label}>Data de Envio</Text>
        <Text style={styles.value}>{startDate}</Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.label}>Duração</Text>
        <Text style={styles.value}>{duration}</Text>
      </View>

      <View style={styles.separator} />
      <View style={styles.row}>
        <Text style={styles.label}>Status</Text>
        <View style={styles.statusContainer}>
          {getIcon(status)}
          <Text style={[styles.value, { textAlign: 'left', flex: 0 }]}>
            {status}
          </Text>
        </View>
      </View>
    </View>
  );
}

export const CardRow = memo(CardRowComponent);
